// extracted by mini-css-extract-plugin
module.exports = {"button":"BookNowButton_button__JfQxX","subsPriceButton":"BookNowButton_subsPriceButton__HHuzV"};